import script from "./CompanyChatWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyChatWidget.vue?vue&type=script&setup=true&lang=js"

import "./CompanyChatWidget.vue?vue&type=style&index=0&id=7a153ff9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a153ff9"]])

export default __exports__